<template>
  <div>
    <div class="team-calendar-activator text-dark no-print"
         :content="'<p class=' + 'tooltip-shortcut' + '>' + $t('vue2.common.press') + '<span>S</span></p>'"
         v-tippy="{arrow: true,placement : 'right'}"
         :class="{'team-calendar-activator--is-active': showTeamCalendar}"
         @click="toggleShowTeamCalendar">
      <button class=" box-shadow submit-button button--rounded">
        <span v-if="!showTeamCalendar" class="icon-users"></span>
        <span v-else class="icon-cross2"></span>
      </button>
      <p v-html="i18n[locale]['button_text']"></p>
    </div>
    <transition name="fadeIn">
      <div class="background-overlay" v-if="showTeamCalendar"></div>
    </transition>
    <transition name="slideUp">
      <div class="overlay-calendars text-dark" v-show="showTeamCalendar">
        <div class="team-calendar" :class="{'team-calendar--week-view': calView === 'resourceTimeGridFiveDay' || calView === 'overlayWeek'}">
          <div class="team-calendar__header flex space-between no-print">
            <h1>{{ i18n[locale]['team_calendar'] }}</h1>
            <div @click="closeTeamCalendar"
                 class="icon__bg-circle team-calendar__close-cross pointer font-large no-print">
              <span class="icon-cross2"></span>
            </div>
          </div>
          <div class="team-calendar__body">
            <calHeader
              :date="date"
              :calview="calView"
              :itemsSelected="selectedRess"
              :selectedScrollOption="selectedScrollOption"
              :isDragAndDropOn="isDragAndDropOn"
              :isDragAndDropPossible="isUserCanEditCalendar"
              @setIsDragAndDropOn="setIsDragAndDropOn"
              @dateChange="setDate"
              @setView="setCalView"
              @updateEvents="updateEvents"
              @usersUpdated="setSelectedRess"
              @changedSortOption="setSortOption"
              @setSelectedScrollOption="setSelectedScrollOption">
            </calHeader>
            <div class="team-calendar__calendars"
                 :class="{'team-calendar__calendars--loading-events': isLoadingEvents && (isCalendarView || isPresenceTableView)}"
                 id="printTeamCalendar">
              <spinner v-if="isLoading"></spinner>
              <div class="team-calendar__loader-container" v-if="isLoadingEvents && (isCalendarView || isPresenceTableView)">
                <spinner bg-color="#fff"></spinner>
                <h4 class="italic">{{ i18n[locale]['loading_events'] }}</h4>
              </div>
              <Collisions
                v-if="calView === 'doubleBookings'"
                :date="date"
                :show="showTeamCalendar"
                @prevDay="setPrevDay"
                @nextDay="setNextDay"
                @updated="hasChanges = true"
              ></Collisions>
              <TeamCalendarPresenceTable
                v-if="isPresenceTableView && selectedRess.length > 0 && !isLoading"
                :calendars="selectedRess"
                :events="events"
                :date="date"
                :locale="locale"
                :isShowWeekends="isShowWeekends">
              </TeamCalendarPresenceTable>
              <dScheduler v-if="isSchedulerView && !isLoading"
                          :calendars="selectedRess"
                          :events="events"
                          :title="schedulerDate"
                          :isLoading="isLoadingEvents">
              </dScheduler>
              <dScheduler
                v-if="isShowSchedulerShortcut"
                :title="schedulerDate"
                :calendars="theSchedulerCalendars"
                :isLoading="isLoadingEvents"
                :events="theSchedulerEvents"
                :sortBy="theSortOptionForAllSchedules">
              </dScheduler>
              <transition name="zoomIn">
                <DCalendarShowEvent
                  v-if="activeEvent"
                  :event="activeEvent"
                  :calendar="activeCalendar"
                  :initCalendarId="activeEventCalendarId"
                  @updated="onEventUpdated"
                  @close="setActiveEvent(null)">
                </DCalendarShowEvent>
              </transition>
              <div class="calendar_container"
                   :class="{'calendar_container--side-scroll': selectedScrollOption === 'horizontal'}"
                   v-if="isOverlayWeekView && selectedRess.length > 0 && !isLoading">
                <div class="d-cals">
                  <div class="d-cals__calendar">
                    <div class="overlay-legend" v-if="overlayCalendarLegend.length > 0">
                      <div class="overlay-legend__item" v-for="item in overlayCalendarLegend" :key="item.id">
                        <span class="overlay-legend__swatch" :style="{backgroundColor: item.color}"></span>
                        <span class="overlay-legend__label">{{ item.name }}</span>
                      </div>
                    </div>
                    <DCalendar
                      :initNumberOfDays="5"
                      :isMultiCalendar="false"
                      :isShowStudents="true"
                      :date="date"
                      :isEventsClickable="isUserCanEditCalendar"
                      :events="overlayEvents"
                      :startTime="startTime"
                      :endTime="endTime"
                      :isShowWeek="true"
                      :isShowWeekends="true"
                      :calendarId="overlayCalendarId"
                      :calendarName="i18n[locale]['overlay_week_title']"
                      :showSidebar="true"
                      :isShowAsList="false"
                      @onEventClick="setActiveEventForOverlay">
                    </DCalendar>
                  </div>
                </div>
              </div>
              <div class="calendar_container" :class="{'calendar_container--side-scroll': selectedScrollOption === 'horizontal'}" ref="calContainerRef"
                   v-if="selectedRess.length > 0 && isCalendarView && !isOverlayWeekView && !isPresenceTableView && !isLoading">
                <div class="d-cals">
                  <div class="d-cals__calendar" v-for="(calendar, idx) in selectedRess" :key="calendar.id">
                    <DCalendar
                      :initNumberOfDays="userCustomNumberOfDays"
                      :isMultiCalendar="true"
                      :isShowStudents="true"
                      :date="date"
                      :isEventsClickable="isUserCanEditCalendar"
                      :isEditable="isDragAndDropActive"
                      :isMoveOnly="true"
                      :calendar="calendar"
                      :events="getCalendarEvents(calendar.id)"
                      :startTime="startTime"
                      :endTime="endTime"
                      :isShowWeek="isShowWeek"
                      :isShowWeekends="isShowWeekends"
                      :calendarId="calendar.id"
                      :calendarName="calendar.name"
                      :showSidebar="idx % 5 === 0"
                      :isShowAsList="isListView"
                      @onEventClick="setActiveEvent($event, calendar)"
                      @onEventMove="moveEvent">
                    </DCalendar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import calHeader from './TeamCalendarHeader'
import dScheduler from '../DScheduler/DScheduler'
import spinner from '../common/Loader'
import DCalendar from '../DCalendar/DCalendar'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import moment from 'moment'
import Collisions from '../Collisions/Collisions'
import DCalendarShowEvent from '../DCalendar/DCalendarShowEvent'
import TeamCalendarPresenceTable from './TeamCalendarPresenceTable'

export default {
  components: {TeamCalendarPresenceTable, DCalendarShowEvent, Collisions, DCalendar, calHeader, dScheduler, spinner},
  data () {
    return {
      i18n: {
        da: {
          button_text: 'Skema-<br>overblik',
          team_calendar: 'Skemaoverblik',
          loading_events: 'Henter lektioner..',
          overlay_week_title: 'Samlet overblik'
        },
        en: {
          button_text: 'Schedule<br>overview',
          team_calendar: 'Schedule overview',
          loading_events: 'Loading events..',
          overlay_week_title: 'Overlay week'
        },
        nb: {
          button_text: 'Timeplan-<br>overblikk',
          team_calendar: 'Timeplanoverblikk',
          loading_events: 'Loading events..',
          overlay_week_title: 'Samlet uke'
        }
      },
      showTeamCalendar: false,
      calView: 'resourceTimeGridFiveDay',
      date: moment().format('YYYY-MM-DD 00:00'),
      maxRessLength: 4,
      selectedRess: [],
      events: [],
      prevCounter: 0,
      nextCounter: 0,
      todayCounter: 0,
      theSchedulerCalendars: [],
      theSchedulerEvents: [],
      rooms: [],
      isLoading: false,
      isLoadingEvents: false,
      timeout: null,
      _keyListener: null,
      theSortOptionForAllSchedules: null,
      activeEvent: null,
      activeCalendar: null,
      activeEventCalendarId: null,
      selectedScrollOption: '',
      isDragAndDropOn: false,
      hasChanges: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    schoolId () {
      return this.$store ? this.$store.getters.schoolId : window.SCHOOL.id
    },
    locale () {
      return this.user && this.user.locale ? this.user.locale : 'en'
    },
    userSettings () {
      return this.$store.state.userSettings
    },
    allCalendars () {
      return this.$store.state.calendars
    },
    userCalendars () {
      return this.$store.getters.userCalendars
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    isListView () {
      return this.calView === 'listView'
    },
    isSchedulerView () {
      return this.calView === 'schedulerView'
    },
    isPresenceTableView () {
      return this.calView === 'presenceTable'
    },
    isOverlayWeekView () {
      return this.calView === 'overlayWeek'
    },
    isShowSchedulerShortcut () {
      return this.calView === 'scheduler' || this.calView === 'scheduler__all_cals' || this.calView === 'scheduler__all_users' || this.calView === 'scheduler__all_klass'
    },
    isCalendarView () {
      return this.calView === 'resourceTimeGridFiveDay' || this.calView === 'resourceTimeGridDay' || this.calView === 'listView' || this.calView === 'overlayWeek'
    },
    isShowWeek () {
      return this.calView !== 'resourceTimeGridDay'
    },
    isDragAndDropActive () {
      const isDayOrWeekView = this.calView === 'resourceTimeGridDay' || this.calView === 'resourceTimeGridFiveDay'
      return this.isDragAndDropOn && this.isUserCanEditCalendar && isDayOrWeekView
    },
    startDate () {
      let startDate = moment(this.date).format('YYYY-MM-DD 00:00')
      if (this.isOverlayWeekView) {
        startDate = moment(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00')
        return startDate
      }
      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView' || this.calView === 'presenceTable') {
        startDate = moment(this.date).isoWeekday(1).format('YYYY-MM-DD 00:00')
      }
      return startDate
    },
    endDate () {
      let endDate = moment(this.date).format('YYYY-MM-DD 23:59')
      if (this.isOverlayWeekView) {
        endDate = moment(this.date).isoWeekday(7).format('YYYY-MM-DD 23:59')
        return endDate
      }
      if (this.calView === 'resourceTimeGridFiveDay' || this.calView === 'listView' || this.calView === 'presenceTable') {
        if (this.isShowWeekends) {
          endDate = moment(this.date).isoWeekday(7).format('YYYY-MM-DD 23:59')
        } else {
          endDate = moment(this.date).isoWeekday(5).format('YYYY-MM-DD 23:59')
        }
        if (this.userCustomNumberOfDays && this.calView !== 'presenceTable') {
          endDate = moment(this.date).isoWeekday(this.userCustomNumberOfDays).format('YYYY-MM-DD 23:59')
        }
      }
      return endDate
    },
    dateRangeFormatted () {
      // alternative is just to show the month?
      let isInSameMonth = moment(this.startDate).format('MM') === moment(this.endDate).format('MM')
      let start = isInSameMonth ? moment(this.startDate).format('DD[.]') : moment(this.startDate).format('DD[.] MMM')
      if (this.locale !== 'en') {
        if (this.calView !== 'resourceTimeGridDay') {
          return start + ' - ' + moment(this.endDate).format('DD[.] MMM[,] YYYY')
        } else {
          return moment(this.endDate).format('DD[.] MMM[,] YYYY')
        }
      } else {
        start = moment(this.startDate).format('MMM DD')
        let end = isInSameMonth ? moment(this.endDate).format('DD[,] YYYY') : moment(this.endDate).format('MMM DD[,] YYYY')
        if (this.calView !== 'resourceTimeGridDay') {
          return start + ' - ' + end
        } else {
          return moment(this.endDate).format('MMM DD[,] YYYY')
        }
      }
    },
    startTime () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
        const end = moment(this.userSettings.teamCalendarSettingTimes.end)
        const start = moment(this.userSettings.teamCalendarSettingTimes.start)
        if (moment(start).isBefore(end)) {
          return moment(this.userSettings.teamCalendarSettingTimes.start).format('HH:mm:00')
        } else {
          this.$store.dispatch('deleteUserSetting', 'teamCalendarSettingTimes')
        }
      } else {
        return '07:00:00'
      }
    },
    endTime () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes) {
        return moment(this.userSettings.teamCalendarSettingTimes.end).format('HH:mm:00')
      } else {
        return '16:00:00'
      }
    },
    isShowWeekends () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.isShowWeekends) {
        return this.userSettings.teamCalendarSettingTimes.isShowWeekends
      } else {
        return false
      }
    },
    userCustomNumberOfDays () {
      if (this.userSettings && this.userSettings.teamCalendarSettingTimes && this.userSettings.teamCalendarSettingTimes.numberOfDays) {
        return this.userSettings.teamCalendarSettingTimes.numberOfDays
      } else {
        return null
      }
    },
    schedulerDate () {
      return moment(this.date).format('dddd') + ', ' + moment(this.date).format('ll')
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    roomsGetter () {
      return this.$store.getters.roomCalendars
    },
    eventsInHash () {
      let eventsHash = {}
      this.events.forEach(event => {
        if (event.event_type === 'presence') {
          const calId = event.calendar_id
          if (!eventsHash[calId]) {
            eventsHash[calId] = [event]
          } else {
            eventsHash[calId].push(event)
          }
        } else {
          event.calendars.forEach(calendar => {
            const calId = calendar.calendar_id
            if (!eventsHash[calId]) {
              eventsHash[calId] = [event]
            } else {
              eventsHash[calId].push(event)
            }
          })
        }
      })
      return eventsHash
    },
    isUserCanEditCalendar () {
      return this.$store.getters.isUserCanEditCalendar
    },
    overlayCalendarId () {
      return this.selectedRess[0] ? this.selectedRess[0].id : null
    },
    overlayCalendarColors () {
      const palette = [
        '#1f77b4',
        '#ff7f0e',
        '#2ca02c',
        '#d62728',
        '#9467bd',
        '#8c564b',
        '#e377c2',
        '#7f7f7f',
        '#bcbd22',
        '#17becf'
      ]
      const colors = {}
      this.selectedRess.forEach((calendar, index) => {
        let color = calendar && calendar.color ? calendar.color : null
        if (!color && calendar && calendar.color_hex) {
          color = calendar.color_hex
        }
        if (!color && calendar && calendar.color_code) {
          color = calendar.color_code
        }
        if (!color && calendar && calendar.hex_color) {
          color = calendar.hex_color
        }
        if (!color) {
          color = palette[index % palette.length]
        }
        colors[calendar.id] = color
      })
      return colors
    },
    overlayEvents () {
      const colors = this.overlayCalendarColors
      const selectedIds = this.selectedRess.map(calendar => calendar.id)
      const overlay = []
      this.events.forEach(event => {
        if (!event) {
          return
        }
        let calendarIds = []
        if (event.calendars && Array.isArray(event.calendars)) {
          event.calendars.forEach(calendar => {
            if (calendar && calendar.calendar_id && selectedIds.indexOf(calendar.calendar_id) > -1) {
              calendarIds.push(calendar.calendar_id)
            }
          })
        }
        if (calendarIds.length < 1 && event.calendar_id && selectedIds.indexOf(event.calendar_id) > -1) {
          calendarIds = [event.calendar_id]
        }
        if (calendarIds.length < 1) {
          return
        }
        calendarIds.forEach(calendarId => {
          const overlayEvent = {
            ...event,
            calendar_id: calendarId,
            v_overlay_key: `${calendarId}_${event.event_id}`
          }
          if (event.event_type !== 'presence' && colors[calendarId]) {
            overlayEvent.color = colors[calendarId]
          }
          overlay.push(overlayEvent)
        })
      })
      return overlay
    },
    overlayCalendarLegend () {
      const colors = this.overlayCalendarColors
      return this.selectedRess.map(calendar => ({
        id: calendar.id,
        name: calendar.name,
        color: colors[calendar.id] || '#999999'
      }))
    }
  },
  methods: {
    readInitialScrollOption () {
      const key = 'd_team_calendar_scroll_option'
      const val = this.$helpers.getLocalStorage(key)
      if (val) {
        this.selectedScrollOption = val
      }
    },
    setSelectedScrollOption (val) {
      this.selectedScrollOption = val
      const key = 'd_team_calendar_scroll_option'
      if (val === '') {
        this.$helpers.removeLocalStorage(key)
      } else {
        this.$helpers.setLocalStorage(key, val)
      }
    },
    setSortOption (sortBy) {
      this.theSortOptionForAllSchedules = sortBy
    },
    getCalendarEvents (calendarId) {
      return this.eventsInHash[calendarId] ? this.eventsInHash[calendarId] : []
    },
    setActiveEventForOverlay (event) {
      if (!event || !event.obj) {
        this.setActiveEvent(null)
        return
      }
      let calendarId = event.obj.calendar_id
      if (!calendarId && event.obj.calendars && event.obj.calendars.length > 0) {
        calendarId = event.obj.calendars[0].calendar_id
      }
      const calendar = calendarId && this.allCalendarsInHash[calendarId] ? this.allCalendarsInHash[calendarId] : null
      if (!calendar) {
        return
      }
      this.setActiveEvent(event, calendar)
    },
    setNextDay () {
      const newDate = moment(this.date).add(1, 'days')
      this.setDate(newDate)
    },
    setPrevDay () {
      const newDate = moment(this.date).subtract(1, 'days')
      this.setDate(newDate)
    },
    setDate (mom) {
      this.date = mom
      if (this.calView === 'doubleBookings') {
        return
      }
      setTimeout(_ => {
        this.getEvents()
      }, 0)
    },
    setCalView (val) {
      if (this.calView === val) {
        return
      }
      if (val === 'scheduler') {
        this.theSchedulerCalendars = this.roomsGetter
      }
      if (val === 'scheduler__all_cals') {
        this.theSchedulerCalendars = this.$helpers.sortArrOnName(this.allCalendars)
      }
      if (val === 'scheduler__all_users') {
        this.theSchedulerCalendars = this.userCalendars
      }
      if (val === 'scheduler__all_klass') {
        this.theSchedulerCalendars = this.klassCalendars
      }
      this.calView = val
      this.getEvents()
    },
    setCalDate (calDate) {
      if (moment(this.date).format('YYYY-MM-DD') !== moment(calDate).format('YYYY-MM-DD')) {
        this.date = calDate
      }
    },
    setToday () {
      this.todayCounter++
      this.date = moment()
    },
    setSelectedRess (calendars) {
      this.selectedRess = []
      calendars.forEach(calendar => {
        this.selectedRess.push(calendar)
      })
    },
    updateEvents ($event) {
      setTimeout(_ => {
        this.getEvents()
      }, 0)
    },
    setView () {
      this.getEvents()
    },
    getEvents () {
      if (this.calView === 'doubleBookings') {
        return
      }
      if (this.isShowSchedulerShortcut) {
        const calendarIds = this.theSchedulerCalendars.map(cal => cal.id)
        this.isLoadingEvents = true
        this.theSchedulerEvents = []
        docendo.eventsFromCalendars(calendarIds, this.startDate, this.endDate, null, data => {
          const events = data.length > 0 ? JSON.parse(data) : []
          this.theSchedulerEvents = events
          this.isLoadingEvents = false
        })
        return
      }
      if (this.selectedRess.length === 0) {
        return
      }
      const calendarIds = this.selectedRess.map(user => user.id)
      this.isLoadingEvents = true
      this.events = []
      docendo.eventsFromCalendars(calendarIds, this.startDate, this.endDate, null, data => {
        const events = data.length > 0 ? JSON.parse(data) : []
        this.events = events
        this.isLoadingEvents = false
      })
    },
    setShowTeamCalendar () {
      this.showTeamCalendar = true
      if (this.selectedRess.length > 0) {
        this.getEvents()
      }
      const body = document.querySelector('body')
      if (!body.classList.contains('no-scroll')) {
        body.classList.add('no-scroll')
      }
      const onEscape = (e) => {
        if (this.showTeamCalendar && e.keyCode === 27) {
          this.closeTeamCalendar()
        }
      }
      document.addEventListener('keydown', onEscape)
      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', onEscape)
      })
    },
    closeTeamCalendar () {
      this.showTeamCalendar = false
      const body = document.querySelector('body')
      body.classList.remove('no-scroll')
      if (this.hasChanges) {
        this.hasChanges = false
        // Siderne under (kalender, vikardækning) lytter og henter deres events igen
        window.dispatchEvent(new window.CustomEvent('vueTeamCalendarChanged'))
      }
    },
    toggleShowTeamCalendar () {
      if (this.showTeamCalendar) {
        this.closeTeamCalendar()
      } else {
        this.setShowTeamCalendar()
      }
    },
    setIsDragAndDropOn (boolean) {
      this.isDragAndDropOn = boolean
      this.$store.dispatch('updateUserSettings', {'teamcalendar_drag_and_drop': boolean})
    },
    // Brikken findes kun én gang i this.events og deles af alle kolonner, den vises i,
    // så en ændring her flytter den i alle valgte kalendere på én gang
    moveEvent ({event, start, end}) {
      const original = this.events.find(evt => evt.event_id === event.event_id)
      if (!original) {
        return
      }
      const oldStart = original.start
      const oldEnd = original.end
      original.start = moment(start).format()
      original.end = moment(end).format()
      this.$set(original, 'v_is_loading', true)
      const updates = [{
        event_id: original.event_id,
        calendar_id: original.calendar_id,
        start_time: start,
        end_time: end
      }]
      const revert = () => {
        original.start = oldStart
        original.end = oldEnd
        original.v_is_loading = false
        eventbus.toast = {text: 'Something went wrong', 'success': false}
      }
      docendo.updateEvents(original.school_id, updates, success => {
        if (success && success.status === 'error') {
          revert()
          return
        }
        original.v_is_loading = false
        this.hasChanges = true
      }, revert)
    },
    onEventUpdated () {
      this.hasChanges = true
      this.updateEvents()
    },
    setActiveEvent (event, calendar) {
      if (!this.isUserCanEditCalendar) {
        return
      }
      if (!event) {
        this.activeEvent = null
        this.activeCalendar = null
        this.activeEventCalendarId = null
      } else {
        this.activeEvent = event.obj
        this.activeCalendar = calendar
        this.activeEventCalendarId = calendar.id
      }
    }
  },
  beforeMount () {
    window.addEventListener('vue_open_teamcalendar', e => {
      this.setShowTeamCalendar()
    })
    this.readInitialScrollOption()
    this.calView = this.userSettings['teamcalendar_view__tab_1']
    this.theSortOptionForAllSchedules = this.userSettings['teamcalendar_view__sort_option']
    this.isDragAndDropOn = !!this.userSettings['teamcalendar_drag_and_drop']
  },
  mounted () {
    this._keyListener = function (e) {
      //
      if (e.key === 's') {
        if ((e.target.tagName.toUpperCase() === 'BODY')) {
          this.toggleShowTeamCalendar()
        }
      }
    }
    document.addEventListener('keydown', this._keyListener.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this._keyListener)
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.slideUp-enter-active {
  transition: transform .3s;
}

.slideUp-enter, .slideUp-leave-to {
  transform: translateY(100%);
}

.overlay-calendars {
  position: fixed;
  transition: transform .4s;
  bottom: 0;
  left: 0;
  right: 0;
  height: 97vh;
  background-color: #edf0f5;
  overflow-y: hidden;
  z-index: 999999991;
  box-shadow: 0px 10px 40px -10px rgba(0, 64, 128, 0.2);
}

.overlay-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  align-items: center;
  padding: 0.5rem 0.75rem;
  margin-bottom: 0.5rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
}

.overlay-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #3d4340;
}

.overlay-legend__swatch {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  display: inline-block;
}

.overlay-calendars.teamCalIsOpen {
  transform: translateY(0);
}

.team-calendar__header {
  padding: 0px 60px;
  border-bottom: 1px solid #dadce0;
  height: 55px;
}

.team-calendar__body {
  height: calc(97vh - 55px);
  overflow-y: auto;
  padding: 1rem 2rem;
}

.team-calendar__close-cross {
  font-size: 20px !important;
  margin-left: 4rem;
  margin-top: 14px;
}

.team-calendar .user-tags {
  display: flex;
}

.team-calendar .user-tag {
  padding: 4px 6px;
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}

.team-calendar .user-tag__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}

.team-calendar .fc-button-group {
  margin-right: 5px;
}

#monthname {
  display: flex;
  font-size: 1.4rem;
  align-items: center;
  padding-left: 20px;
}

.public-app .fc-unthemed .fc-today {
  background: var(--active-blue);
}

.public-app .fc-v-event {
  cursor: pointer;
  min-height: 10px;
}

.public-app .fc-header-toolbar {
  display: none;
}

.public-app .fc-time-grid .fc-slats td {
  height: 2em;
}

.team-calendar-activator {
  position: fixed;
  left: 0;
  bottom: 25px;
  z-index: 1000;
  border-radius: 50%;
  height: 40px;
  width: 65px;
  text-align: center;
  cursor: pointer;
}

.team-calendar-activator > p {
  color: #ffffff;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  margin-top: 4px;
}

.background-overlay {
  position: fixed;
  left: 0px;
  bottom: 0px;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
}

.fadeIn-enter-active, .fadeIn-leave-active {
  transition: opacity .5s;
}

.fadeIn-enter, .fadeIn-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.flex-1 {
  flex: 1;
}

.justify-end {
  justify-content: flex-end;
}

.bttn--red {
  background-color: #fa565a !important;
  color: white !important;
}

.print-only {
  display: none;
}

.calendar_container {
  padding: 0 1rem;
  background: #ffffff;
}

.calendar_container.calendar_container--side-scroll {
  overflow-x: auto;
  overscroll-behavior: contain;
}

.d-cals {
  display: flex;
  flex-wrap: wrap;
}

.calendar_container.calendar_container--side-scroll .d-cals {
  flex-wrap: initial;
}

.d-cals__calendar {
  flex: 1;
  position: relative;
  height: 650px;
  min-width: 300px;
}

.team-calendar.team-calendar--week-view .d-cals__calendar {
  min-width: 25%;
  max-width: 100%;
}

@media print {
  .d-cals__calendar {
    max-width: initial;
    min-width: 20%;
    flex: 1 0 21%;
  }
  .print-only {
    display: block;
  }

  .d-cals {
    page-break-before: always;
  }

  .d-cals__calendar {
    page-break-before: always;
  }
}

.team-calendar__calendars {
  position: relative;
  height: 100%;
  background: #ffffff;
}

.team-calendar__calendars--loading-events:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(255 255 255 / 40%);
  z-index: 12;
}

.team-calendar__loader-container {
  position: absolute;
  top: 5.5rem;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 13;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.team-calendar__loader-container h4 {
  margin-top: -2rem;
}

</style>



// WEBPACK FOOTER //
// TeamCalendar.vue?53a9c27d